<template>
	<div class="hw_stat">
		<div class="stats__wrap uk-margin-bottom">
			<date-picker
        :range="true"
        :format="'DD-MM-YYYY'"
        v-model="dates"
        valueType="format"
        :placeholder="'Диапазон дат'"
        @input="getStatHomeworks"
      ></date-picker>
		</div>

		<ul class="hw_stat__items" v-if="Object.keys(items).length > 0">
			<HwStat v-for="(train, key) in items" :train="train" :date="key" :key="key" />
		</ul>
	</div>
</template>

<script>
  import HwStat from "./HwStat";
  export default {
    name: "hw-stats",
    inject: ['http'],
    props: ['student_id'],
	  components: {
      HwStat
	  },
    data() {
      return {
        dates: '',
        items: ''
      }
    },
    methods: {
      getStatHomeworks() {
        if (!this.dates.includes(null)) {
          let data = {
            dates: this.dates,
            student_id: this.student_id
          };
          this.http.post('onGetStatHomeworks', data).then(res => {
            this.items = res.data
            console.log('stat', this.items)
          })
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
          
        } else {
          swal('Выберите даты', '', 'warning');
        }
      }
    }
  }
</script>